import { ShieldCheck } from 'lucide-react';
import type { ReactNode } from 'react';
import { Logo } from '../../components/brand/Logo';
import { AuthTabs } from './AuthTabs';
import { ShowcasePanel } from './ShowcasePanel';

type Props = {
  children: ReactNode;
};

export function AuthLayout({ children }: Props) {
  return (
    <div className="min-h-screen bg-white font-sans text-slate-900 antialiased lg:grid lg:grid-cols-[minmax(0,0.9fr)_1.1fr]">
      <div className="flex min-h-screen flex-col justify-between px-8 py-10 sm:px-12 lg:px-16 lg:py-14">
        <div>
          <Logo />

          <div className="mt-10 flex justify-center lg:justify-start">
            <AuthTabs />
          </div>

          <div className="mt-12 max-w-md">{children}</div>
        </div>

        <footer className="mt-12 flex items-center justify-between text-xs text-slate-400">
          <span>© 2026 NexaClaim AI — HIPAA aligned</span>
          <span className="inline-flex items-center gap-1.5">
            <ShieldCheck className="h-3.5 w-3.5 text-primary-500" />
            Encrypted in transit
          </span>
        </footer>
      </div>

      <div className="hidden lg:block">
        <ShowcasePanel />
      </div>
    </div>
  );
}
